export default __webpack_public_path__ + "static/media/help.0b11810c.png";